import React, { useState } from "react";
import { Row, Col  } from 'reactstrap';
import { Divider, withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import DeleteObject from '../Common/DeleteObject.js';
import {FormattedMessage} from 'react-intl';
import DataServiceSQL from "../../DataService/DataServiceSQL";

/** Used by AddChild.js and DeleteChild.js
 *  Each item represents a child to add/delete in a group
 */
const ItemListSentRequest = (props) => {

    const [displayCancelPopup, setDisplayCancelPopup] = useState(false);

    //Function to control cancel popup display or not
    const manageCancelPopupDisplay = () => {
      setDisplayCancelPopup(!displayCancelPopup);
    }

    //Function to reload request sent list after cancelation
    const closeAfterCancelation = () => {
      props.retrieveRequestsList();
      manageCancelPopupDisplay();
    }

    //Refuse profile creation request
    const cancel = () => {
        setDisplayCancelPopup(true);
    }

    // Cancel a structure-targeted pending invitation by calling the
    // dedicated DELETE endpoint, then refresh the list.
    const cancelStructurePending = async () => {
      try {
        await DataServiceSQL.deletePatientPendingInvite(request.FK_patient, request.request_id);
      } catch (e) {
        console.log(e);
      }
      props.retrieveRequestsList();
    };

    const { request } = props;

    // Branch on item_type so a single list can display heterogeneous entries.
    if (request.item_type === 'structure_pending') {
      return (
        <div>
          <Divider style={{ width: "100%", backgroundColor:"#000000", marginTop: "5px", marginBottom: "5px" }} />
          <Row>
            <Col style={{ maxWidth: "50%", textAlign: "center", paddingTop: '6px', fontWeight: "bold"}}>
              <div>{request.patient_label}</div>
              <div style={{ fontWeight: "normal", fontSize: "0.9em", color: "#555" }}>
                <FormattedMessage id="invitation.structureTarget" defaultMessage="Structure"/>: {request.recipient_structure_name}
              </div>
              <div style={{ fontWeight: "normal", fontSize: "0.85em", color: "#888" }}>
                <FormattedMessage id="invitation.statusPending" defaultMessage="Pending"/>
              </div>
            </Col>
            <Col style={{ width: "50%", textAlign: "center", fontWeight: "bold"}}>
              <button onClick={cancelStructurePending} className="btn btn-danger">
                <FormattedMessage id="button.cancelReq" defaultMessage="Cancel request"/>
              </button>
            </Col>
          </Row>
        </div>
      );
    }

    if (request.item_type === 'structure_accepted') {
      return (
        <div>
          <Divider style={{ width: "100%", backgroundColor:"#000000", marginTop: "5px", marginBottom: "5px" }} />
          <Row>
            <Col style={{ maxWidth: "100%", textAlign: "center", paddingTop: '6px', fontWeight: "bold"}}>
              <div>{request.patient_label}</div>
              <div style={{ fontWeight: "normal", fontSize: "0.9em", color: "#555" }}>
                <FormattedMessage id="invitation.structureTarget" defaultMessage="Structure"/>: {request.structure_name}
              </div>
              <div style={{ fontWeight: "normal", fontSize: "0.85em", color: "#2a8a2a" }}>
                <FormattedMessage id="invitation.statusAccepted" defaultMessage="Accepted"/>
                {request.sharing_type ? ` (${request.sharing_type})` : ''}
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    // Default: legacy PSAD user-to-user invitation
    return (
      <div>
        <Divider style={{ width: "100%", backgroundColor:"#000000", marginTop: "5px", marginBottom: "5px" }} />
        <Row>
          <Col style={{ maxWidth: "50%", textAlign: "center", paddingTop: '6px', fontWeight: "bold"}}>
            {request.recipient_mail_address}
          </Col>
          <Col style={{ width: "50%", textAlign: "center", fontWeight: "bold"}}>
            <button onClick={() => {cancel(request.request_id)}} className="btn btn-danger">
              <FormattedMessage id="button.cancelReq" defaultMessage="Cancel request"/>
            </button>
          </Col>
          {displayCancelPopup ?
            <DeleteObject closeAfterDelete={closeAfterCancelation} cancelPopup={manageCancelPopupDisplay} requester={props.request.requester_mail_address} recipient={props.request.recipient_mail_address} object_type={"request"}/>
            :
            null
          }
        </Row>
      </div>
    );
};
export default withStyles(Constants.styles)(ItemListSentRequest);